import styled from 'styled-components'

export const ListCard = styled.article`
  background: white;
  box-shadow: '4px 4px 18px -5px rgba(218, 221, 232, 0.8)';
  border-radius: 15px;
  min-width: 70%;
  min-height: 3rem;
  padding: 0.5rem;
  margin: 1rem;

  display: flex;
  flex-direction: column;
  align-items: left;

  @media (max-width: 768px) {
    display: none;
  }
`
export const OuterListCard = styled.article`
  background: white;
  box-shadow: '4px 4px 18px -5px rgba(218, 221, 232, 0.8)';
  border-radius: 15px;
  width: 70%;
  min-height: 3rem;

  margin: 1rem;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`
export const InnerLeftListCard = styled.article`
  background: white;
  box-shadow: '4px 4px 18px -5px rgba(218, 221, 232, 0.8)';
  border-radius: 15px;
  width: 70%;
  min-height: 3rem;
  padding: 0.5rem;
  margin: 1rem;

  display: flex;
  flex-direction: column;
  align-items: left;
  align-self: flex-start;
  @media (max-width: 768px) {
    display: none;
  }
`
export const InnerRightListCard = styled.article`
  background: white;
  display: flex;
  align-items: center;

  width: 50px;

  @media (max-width: 768px) {
    display: none;
  }
`
export const L0 = styled.p`
  align-self: flex-start;
  color: #505887;
  font-size: 1.5rem;
  font-weight: 500;
  padding: 0.1rem;
  margin: 1rem;
  margin-left: 1rem;
`

export const L1 = styled.p`
  color: #505887;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.1rem;
  margin: 0.1rem;
  margin-left: 1rem;
`
export const L2 = styled.p`
  color: #718ebf;
  font-size: 0.9rem;
  font-weight: 400;
  padding: 0.1rem;
  margin: 0.1rem;
  margin-left: 1rem;
`

export const Container = styled.div`
  background: #f5f7fa;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 768px) {
    display: none;
  }
`
